var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer-toparea tm-padding-section" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row widgets footer-widgets" }, [
          _c("div", { staticClass: "col-lg-3 col-md-6 col-12" }, [
            _c("div", { staticClass: "single-widget widget-info" }, [
              _c(
                "a",
                { staticClass: "widget-info-logo", attrs: { href: "/" } },
                [
                  _c("img", {
                    attrs: {
                      alt: "Happpy Order logo",
                      src: "assets/images/logo/logo-dark.png"
                    }
                  })
                ]
              ),
              _c("p", [
                _vm._v(
                  "Happy Order chuyên cung cấp cho khách hàng các giải pháp tìm kiếm sản phẩm và nhập hàng trực\n                        tiếp từ các trang thương mại điện tử hàng đầu như taobao, 1688, tmall ...với mức chi phí rẻ\n                        nhất, thời gian nhanh nhất, làm việc trách nhiệm nhất."
                )
              ]),
              _c("ul", { staticClass: "widget-info-social" }, [
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href:
                          "https://www.facebook.com/dathangtaobao1688renhat/"
                      }
                    },
                    [_c("i", { staticClass: "fab fa-facebook-f" })]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://zalo.me/0911353354"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "zalo",
                          src: "assets/images/icons/zalo.png"
                        }
                      })
                    ]
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-6 col-12" }, [
            _c("div", { staticClass: "single-widget widget-contact" }, [
              _c("h5", { staticClass: "widget-title" }, [_vm._v("Liên hệ")]),
              _c("ul", [
                _c("li", [
                  _c("i", { staticClass: "fas fa-map-marker-alt" }),
                  _c("p", [
                    _vm._v(
                      "Phòng 403 - Tòa CT1A - Chung cư VOV - 499 Lương Thế Vinh - Nam Từ Liêm - Hà Nội"
                    )
                  ])
                ]),
                _c("li", [
                  _c("i", { staticClass: "fas fa-envelope" }),
                  _c("p", [
                    _vm._v("Email: "),
                    _c("a", { attrs: { href: "mailto:hotro@happyorder.vn" } }, [
                      _vm._v("hotro@happyorder.vn")
                    ])
                  ])
                ]),
                _c("li", [
                  _c("i", { staticClass: "fas fa-phone" }),
                  _c("p", [
                    _c("a", { attrs: { href: "tel:0963353354" } }, [
                      _vm._v("0963 353 354")
                    ])
                  ]),
                  _c("p", [
                    _c("a", { attrs: { href: "tel:0911353354" } }, [
                      _vm._v("0911 353 354")
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-6 col-12" }, [
            _c("div", { staticClass: "single-widget widget-recentpost" }, [
              _c("h5", { staticClass: "widget-title" }, [_vm._v("Hướng dẫn")]),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "widget-recentpost-image",
                      attrs: { href: "javascript:void(0)" }
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "logo",
                          src: "assets/images/logo/logo-light.png"
                        }
                      })
                    ]
                  ),
                  _c("div", { staticClass: "widget-recentpost-content" }, [
                    _c("h6", [
                      _c("a", { attrs: { href: "javascript:void(0)" } }, [
                        _vm._v("Hướng dẫn nạp tiền/thanh toán")
                      ])
                    ]),
                    _c("span", [_vm._v("Thứ Hai, 30-09-2019")])
                  ])
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "widget-recentpost-image",
                      attrs: { href: "javascript:void(0)" }
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "logo",
                          src: "assets/images/logo/logo-light.png"
                        }
                      })
                    ]
                  ),
                  _c("div", { staticClass: "widget-recentpost-content" }, [
                    _c("h6", [
                      _c("a", { attrs: { href: "javascript:void(0)" } }, [
                        _vm._v("Hướng dẫn đặt hàng")
                      ])
                    ]),
                    _c("span", [_vm._v("Thứ Hai, 30-09-2019")])
                  ])
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-6 col-12" }, [
            _c("div", { staticClass: "single-widget widget-recentpost" }, [
              _c("h5", { staticClass: "widget-title" }, [
                _vm._v("Happy Order")
              ]),
              _c("ul", [
                _c("li", [
                  _c("a", { attrs: { href: "#" } }, [_vm._v("Đăng ký")])
                ]),
                _c("li", [
                  _c("a", { attrs: { href: "#" } }, [_vm._v("Đăng nhập")])
                ]),
                _c("li", [
                  _c(
                    "a",
                    { staticClass: "widget-info-logo", attrs: { href: "#" } },
                    [
                      _c("img", {
                        attrs: {
                          src: "assets/images/brand-logo/bo-cong-thuong.png"
                        }
                      })
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }